import classNames from "classnames";
import React from "react";
import { graphql, useStaticQuery } from "gatsby";
import { SEARCH_EXCLUDE_CLASSNAME } from "../SearchIndex";
import { PostTile } from "../Tile";

interface Props {
  related: any[];
}

export const RelatedPosts = ({ related }: Props) => {
  const {
    enriseSettings: { plural, single },
  } = useStaticQuery(query);

  if (!related || related?.length === 0) {
    return null;
  }

  return (
    <section
      className={classNames(
        SEARCH_EXCLUDE_CLASSNAME,
        "relative z-20 w-full bg-brand-gray text-white"
      )}
    >
      <div className="container grid grid-cols-1 gap-6 py-12 md:grid-cols-2 lg:grid-cols-3">
        <p className="h2 hidden text-center md:col-span-2 md:block lg:col-span-3">
          {related?.length > 1 ? plural : single}
        </p>
        <p className="h2 text-center md:col-span-2 md:hidden lg:col-span-3">
          {single}
        </p>
        {related?.map(
          (item, i) =>
            item.__typename !== "WpCase" && (
              <PostTile
                key={i}
                post={item}
                className={classNames({
                  "hidden md:flex": i === 1,
                  "hidden lg:flex": i === 2,
                })}
              />
            )
        )}
      </div>
    </section>
  );
};

const query = graphql`
  {
    enriseSettings {
      plural: relatedPostsTitle
      single: relatedPostTitle
    }
  }
`;
